import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { InventoryEntryDetailModel } from 'src/app/models/inventory/inventory-entry-detail.model';
import { InventoryEntryModel } from 'src/app/models/inventory/inventory-entry.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { SubrentalEntryDetailCaptureTableModel } from 'src/app/models/tables/subrental/subrental-entry-detail-capture-table.model';
import { SubrentalEntryDetailService } from 'src/app/services/subrental/subrental-entry-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';
import { ImportSubrentalEntryComponent } from '../../subrental-entry/import-subrental-entry/import-subrental-entry.component';
import { InventoryEntryStateEnums } from 'src/app/enum/inventory-entry-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { OptionWindow } from 'src/app/enum/option-window-enums';

@Component({
  selector: 'app-subrental-entry-detail',
  templateUrl: './subrental-entry-detail.component.html',
  styleUrls: ['./subrental-entry-detail.component.scss'],
  standalone: false
})
export class SubrentalEntryDetailComponent implements OnInit {
  @ViewChild('importDetail') importDetailModalComponent?: CustomModalComponent | null = null;

  @Input('subrentalEntryModel')
  set changeSubrental(changeSubrental: InventoryEntryModel) {
    this.changeSubrentalEntry(changeSubrental);
  }

  @Input('disabledActions')
  set changeDisable(disable: boolean) {
    this.tableActions = disable ? [] : this.getDefaultActions();
    this.disabledButton = disable;
  }
  @Input() listBranches: any[] = [];
  @Input() quantityDetails: number = 0;
  @Input() disabledDetail: boolean = false;
  @Input() userAuthenticated: UserModel = new UserModel();
  @Input() permissionsUser: OptionWindowModel[] = [];
  @Input() permissionUpdatable: boolean = false;
  @Output() emitQuantityDetails = new EventEmitter<number>();

  ascendant: boolean = true;
  columnSort: string | null = null;
  componentImport = ImportSubrentalEntryComponent;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  detailData: PagedResponseModel<SubrentalEntryDetailCaptureTableModel> = new PagedResponseModel<SubrentalEntryDetailCaptureTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  disabledButton: boolean = true;
  disabledImportButton: boolean = true;
  isFormView: boolean = false;
  inputsForImport$ = new BehaviorSubject<any>({
    subrentalEntryModel: new InventoryEntryModel(),
    nameBranch: ''
  })
  limit: number = 10;
  nameBranch: string = '';
  subrentalEntryDetail: InventoryEntryDetailModel = new InventoryEntryDetailModel();
  outputForImport$ = new Subject<any>();
  page: number = 1;
  subscriptionForImport: Subscription;
  subrentalEntryModel: InventoryEntryModel = new InventoryEntryModel();
  tableActions: TableAction[] = [];

  constructor(private subrentalEntryDetailService: SubrentalEntryDetailService,
    private toastHandlerService: ToastHandlerService) {
  }

  async ngOnInit() {
    await this.getColumns();
    this.subscriptionForImport = this.outputForImport$.subscribe(({ type }) => {
      switch (type) {
        case 'updateList':
          this.getSubrentalEntryDetailsBySubrentalEntry();
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }


  changeSubrentalEntry(changeSubrental: InventoryEntryModel) {
    this.subrentalEntryModel = changeSubrental;


    this.disabledImportButton = this.subrentalEntryModel.inventoryEntryId === 0 ||
      this.subrentalEntryModel.inventoryEntryStateId !== InventoryEntryStateEnums.open;

    if (this.subrentalEntryModel.inventoryEntryStateId !== InventoryEntryStateEnums.open) {
      this.isFormView = false;
    }

    if (!this.disabledImportButton) {
      this.updateInputs();
    }
    if (this.subrentalEntryModel.inventoryEntryId != 0) {
      this.clearSelectionTrigger++;
      this.nameBranch = this.listBranches.find(x => x.value == this.subrentalEntryModel.branchId).label;
      this.getSubrentalEntryDetailsBySubrentalEntry();
      this.page = 1;
    } else {
      this.detailData = new PagedResponseModel<SubrentalEntryDetailCaptureTableModel>();
    }

  }

  async createNewDetail() {
    this.subrentalEntryDetail = new InventoryEntryDetailModel();
    this.getFormView(true);
  }

  async deleteSubrentalEntry(selectedIds: number[]) {
    if (selectedIds.length === 0) return;

    const result = await Swal.fire({
      title: 'Atención',
      text: "¿Realmente desea eliminar el artículo?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.subrentalEntryDetailService.deleteSomeDetails(selectedIds));
        this.toastHandlerService.showToast('success', 'El artículo fue eliminado exitosamente.', 'Atención');
        this.subrentalEntryDetail = new InventoryEntryDetailModel();
        this.clearSelectionTrigger++;
        this.getSubrentalEntryDetailsBySubrentalEntry();
      } catch (error) {
        console.error('Error al eliminar el artículo del despiece .', error);
      }
    }
  }

  async getColumns() {
    try {
      this.detailHeader = await firstValueFrom(this.subrentalEntryDetailService.getColumnsForDetailCapture());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  getDefaultActions(): TableAction[] {
    return [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      }
    ];
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async getSubrentalEntryDetailsBySubrentalEntry() {
    try {
      this.detailData = await firstValueFrom(this.subrentalEntryDetailService.getSubrentalEntryDetailsForCapture(this.subrentalEntryModel.inventoryEntryId, this.page, this.limit, this.columnSort, this.ascendant,));
      this.emitQuantityDetails.emit(this.detailData.totalItems);
    } catch (error) {
      console.error('Error al buscar los detalles de la entrada de subalquiler.', error);
    }
  }



  async onAction(event: { action: string, item?: SubrentalEntryDetailCaptureTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit') {
      const response = await firstValueFrom(this.subrentalEntryDetailService.getSubrentalEntryDetailById(event.item!.id));
      if (response)
        this.subrentalEntryDetail = response;
      this.getFormView(true);
    }
    if (event.action === 'bulk-delete' && event.selectedItems) {
      this.deleteSubrentalEntry(event.selectedItems);
    }
  }


  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getSubrentalEntryDetailsBySubrentalEntry();
  }

  async openImportModal() {
    if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.Importar)) {
      if (this.permissionUpdatable) {
        if (this.detailData.totalItems > 0) {
          this.toastHandlerService.showToast('warning', `La entrada ya contiene registros. Debe estar vacía para poder importar.`);
          return;
        }
        this.updateInputs();
        this.importDetailModalComponent && this.importDetailModalComponent.show();
      } else {
        this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para la edición de Entradas de Subalquiler. Comuníquese con el administrador del sistema.`);
      }
    } else {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para importar Entradas de Subalquiler, comuniquese con el administrador del sistema.`);
    }
  }

  updateInputs() {
    this.inputsForImport$.next({
      subrentalEntryModel: this.subrentalEntryModel,
      nameBranch: this.nameBranch
    });
  }
}
